.page {
  min-width: 0;
  overflow-wrap: anywhere;
  display: grid;
  gap: var(--space-10);
}
.page h1 {
  font: var(--type-h1);
  letter-spacing: var(--tracking-h1);
  color: var(--color-content-primary);
  margin: 0;
}
.lead {
  max-width: 65ch;
  color: var(--color-content-secondary);
  font: var(--type-body-large);
  margin: 0;
}
.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--space-8);
  align-items: start;
}
.panel {
  padding: var(--space-8);
  border: var(--border-default) solid var(--color-border-subtle);
  border-radius: var(--radius-surface);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.panel h2 {
  font: var(--type-h3);
  letter-spacing: var(--tracking-h3);
  color: var(--color-content-primary);
  margin: 0;
}
.panel h3 {
  font: var(--type-h4);
  letter-spacing: var(--tracking-h4);
  color: var(--color-content-primary);
  margin: 0;
}
.fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: var(--space-4);
}
.wide {
  grid-column: 1 / -1;
}
.group {
  border: 0;
  padding: 0;
  margin: 0;
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}
.group legend {
  font: var(--type-h3);
  font-weight: 600;
  letter-spacing: var(--tracking-h3);
  margin-bottom: var(--space-5);
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}
.note {
  color: var(--color-content-secondary);
  font: var(--type-compact);
  margin: 0;
}
.error {
  color: var(--color-negative-content);
  padding: var(--space-4);
  border: var(--border-default) solid currentColor;
  border-radius: var(--radius-control);
}
.notice {
  padding: var(--space-5);
  border: var(--border-default) solid var(--color-border-subtle);
  border-radius: var(--radius-control);
  background: var(--color-bg-subtle);
  color: var(--color-content-secondary);
}
.details {
  columns: 4;
  column-gap: var(--space-6);
  margin: 0;
}
.details div {
  display: grid;
  align-content: start;
  gap: var(--space-1);
  min-width: 0;
  break-inside: avoid;
  margin-bottom: var(--space-4);
  padding-top: var(--space-3);
  border-top: var(--border-default) solid var(--color-border-subtle);
}
.details dt {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}
.details dd {
  margin: 0;
  overflow-wrap: anywhere;
  font: var(--type-compact);
}
.scopeCards {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  list-style: none;
  margin: 0;
  padding: 0;
}
.scopeCard {
  display: grid;
  gap: var(--space-1);
  min-width: 10rem;
  padding: var(--space-2) var(--space-3);
  border: var(--border-default) solid var(--color-border-subtle);
  border-radius: var(--radius-control);
  background: var(--color-bg-subtle);
}
.scopeCard code {
  color: var(--color-content-primary);
  font: var(--type-compact);
  overflow-wrap: anywhere;
}
.scopeCard span {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}
.scopeField {
  display: grid;
  align-content: start;
  gap: var(--space-2);
  min-width: 0;
}
.scopeFieldLabel {
  color: var(--color-content-primary);
  font: var(--type-compact);
  font-weight: 600;
}

.onboarding {
  --input-height: 44px;
  gap: var(--space-4);
}

.onboarding > header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: var(--space-8);
}

.onboarding > header h1 {
  font-size: clamp(1.75rem, 2.6vw, 2.5rem);
  line-height: 1.15;
  letter-spacing: var(--tracking-display);
}

.onboarding > header > :last-child {
  flex: 0 0 16rem;
  border-top: 0;
}

.letterForm {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 1.2fr) minmax(0, 1fr);
  align-items: start;
  gap: var(--space-5) var(--space-6);
  min-width: 0;
}

.letterForm > h2 {
  grid-column: 1 / -1;
}

.letterForm > .group {
  border-top: var(--border-default) solid var(--color-border-subtle);
  gap: var(--space-3);
}

.letterForm .group legend {
  font: var(--type-h4);
  margin-bottom: var(--space-4);
}

.letterForm .fields {
  gap: var(--space-3);
}

.letterForm :global(label[data-rac]) {
  font: var(--type-compact);
}

.formActions {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: var(--border-default) solid var(--color-border-subtle);
}

.formActions .note {
  margin-right: auto;
}

.reviewForm {
  grid-template-columns: minmax(0, 1fr);
}

.approval {
  display: grid;
  gap: var(--space-4);
  min-width: 0;
}

.approvalActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.approvalActions > label {
  flex: 1 1 30rem;
}

.approval .notice {
  padding: var(--space-3) var(--space-4);
}

.approval > p {
  font: var(--type-compact);
}

.approval :global(label[data-rac]) {
  font: var(--type-compact);
}

.standalone:has(.confirmationPanel) {
  max-width: var(--shell-content-max);
  min-height: 100dvh;
  padding: var(--space-5) var(--shell-page-padding);
  align-content: center;
  gap: var(--space-5);
}

.page:has(> .confirmationPanel) {
  gap: var(--space-5);
}

.confirmationPanel {
  gap: var(--space-4);
  padding: var(--space-6);
}
.status {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  width: fit-content;
  border: var(--border-default) solid var(--color-border-subtle);
  border-radius: var(--radius-control);
  padding: var(--space-1) var(--space-3);
  text-transform: capitalize;
  font: var(--type-compact);
  background: var(--color-bg-subtle);
}
.standalone {
  max-width: 1040px;
  margin: 0 auto;
  padding: var(--space-12) var(--space-8);
  display: grid;
  gap: var(--space-10);
}
.header {
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}
.brand {
  color: var(--color-content-primary);
  text-decoration: none;
  min-height: var(--target-min);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-weight: 600;
}
/* Plain links only: links styled as buttons keep their own colours. */
.page a:not([class]) {
  color: var(--color-content-primary);
  text-underline-offset: var(--space-1);
}

/* ---- Certificate treatment (public verification page) ---- */
.certificate {
  border: var(--border-default) solid var(--color-border-subtle);
  padding: var(--space-10);
  display: grid;
  gap: var(--space-5);
  border-radius: var(--radius-surface);
  background: var(--color-cert-paper);
  color: var(--color-cert-ink);
  box-shadow: var(--shadow-raised);
  min-width: 0;
}
.certificate > [data-badge] {
  justify-self: start;
}
.certTop {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-4);
  flex-wrap: wrap;
}
.certMasthead {
  display: grid;
  gap: var(--space-1);
  padding-bottom: var(--space-3);
  border-bottom: var(--border-subtle) solid var(--color-border-subtle);
}
.certIssuer {
  font-family: var(--font-serif);
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.5rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.certKind {
  font: var(--type-compact);
  color: var(--color-cert-secondary);
}
.certDomain {
  font-family: var(--font-serif);
  font-weight: 600;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  line-height: 1.15;
  letter-spacing: -0.01em;
  overflow-wrap: anywhere;
}
.certificate .lead {
  font-family: var(--font-serif);
  font-size: 1.0625rem;
  line-height: 1.65;
  color: var(--color-cert-secondary);
}
/* ---- Downloads group ---- */
.downloads {
  border: var(--border-default) solid var(--color-cert-frame);
  border-radius: var(--radius-surface);
  background: var(--color-cert-paper);
  padding: var(--space-6);
  display: grid;
  gap: var(--space-4);
  min-width: 0;
}
.downloads > * {
  min-width: 0;
}
.downloadsTitle {
  font-family: var(--font-serif);
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: var(--color-cert-ink);
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.downloadActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}
/* Download labels wrap instead of widening the layout on narrow screens. */
.downloadActions > * {
  white-space: normal;
  overflow-wrap: anywhere;
  max-width: 100%;
}
.downloadPrimary {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  min-height: var(--target-min);
  padding: 0 var(--space-5);
  border: var(--border-default) solid transparent;
  border-radius: var(--radius-control);
  background: var(--color-cert-emphasis-surface);
  color: var(--color-cert-emphasis-content);
  font: var(--type-body);
  font-weight: 600;
  text-decoration: none;
  white-space: normal;
  text-align: center;
  overflow-wrap: anywhere;
  transition:
    background-color var(--motion-fast) var(--motion-ease),
    border-color var(--motion-fast) var(--motion-ease),
    transform var(--motion-instant) var(--motion-ease);
}
.downloadPrimary:hover {
  border-color: var(--color-cert-accent);
  background: var(--color-bg-hover);
  color: var(--color-cert-ink);
}
.downloadPrimary:active {
  transform: scale(0.98);
}
.code {
  display: block;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: var(--type-code);
  background: var(--color-bg-subtle);
  border-radius: var(--radius-control);
  padding: var(--space-4);
}
/* DNS records to publish: one row each, a long value on one line; Copy carries the full value. */
.recordList {
  display: grid;
  gap: var(--space-3);
  margin: 0;
}
.recordList div {
  display: grid;
  gap: var(--space-1);
  min-width: 0;
}
.recordList dt {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}
.recordList dd {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  margin: 0;
}
.recordValue {
  flex: 1;
  min-width: 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--type-code);
  background: var(--color-bg-subtle);
  border-radius: var(--radius-control);
  padding: var(--space-2) var(--space-3);
}
.list {
  display: grid;
  gap: var(--space-5);
}
@media (max-width: 1279px) {
  .grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 1023px) {
  .letterForm {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .letterForm > .group:first-of-type {
    grid-column: 1 / -1;
  }
  .details {
    columns: 2;
  }
}
@media (max-width: 767px) {
  .onboarding > header {
    display: grid;
    gap: var(--space-3);
  }
  .letterForm {
    grid-template-columns: minmax(0, 1fr);
  }
  .details {
    columns: 1;
  }
  .fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .formActions > button,
  .approvalActions > .actions {
    width: 100%;
  }
  .approvalActions > .actions > button {
    flex: 1 1 100%;
  }
  .standalone {
    padding: var(--space-6) var(--space-4);
  }
  /* Compact card padding keeps the wide primary action inside 320px screens. */
  .panel {
    padding: var(--space-4);
  }
  .certificate {
    padding: var(--space-5);
  }
  .downloads {
    padding: var(--space-4);
  }
}

.workspaceHandoff {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--space-4);
}

/* Long approval labels must remain readable inside narrow onboarding cards. */
.reviewAction {
  white-space: normal;
  text-align: center;
}
.mandateBanner {
  margin-block-end: var(--space-5);
}
.levels {
  display: grid;
  gap: var(--space-2);
}
.levelsLabel {
  font: var(--type-compact);
  font-weight: 600;
  color: var(--color-content-primary);
}
.levelChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.level {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--target-min);
  padding: var(--space-2) var(--space-3);
  border: var(--border-default) solid var(--color-border-default);
  border-radius: var(--radius-control);
  background: var(--color-bg-surface);
  cursor: pointer;
}
.level[data-hovered] {
  border-color: var(--color-border-strong);
}
.level[data-selected] {
  border: var(--border-strong) solid var(--color-action-primary-bg);
}
.level[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
}
.levelTick {
  display: grid;
  flex: none;
  place-items: center;
  width: 18px;
  height: 18px;
  border: var(--border-strong) solid var(--color-border-default);
  border-radius: 50%;
  color: transparent;
}
.level[data-selected] .levelTick {
  border-color: var(--color-action-primary-bg);
  background: var(--color-action-primary-bg);
  color: var(--color-action-primary-fg);
}
.levelName {
  font: var(--type-compact);
  font-weight: 700;
  color: var(--color-content-primary);
  white-space: nowrap;
}
.levelText {
  margin: 0;
  font: var(--type-compact);
  color: var(--color-content-secondary);
}
.levelText strong {
  color: var(--color-content-primary);
}

.intro {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
}
.kicker {
  margin: 0;
  color: var(--color-content-secondary);
  font: var(--type-compact);
  font-weight: 600;
}
.currentLetter {
  border-color: var(--color-border-default);
}
.currentLetter h2 {
  font: var(--type-h2);
  letter-spacing: var(--tracking-h2);
}
.facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 14rem), 1fr));
  gap: var(--space-6);
  margin: 0;
}
.facts div {
  display: grid;
  align-content: start;
  gap: var(--space-2);
  min-width: 0;
  padding-top: var(--space-3);
  border-top: var(--border-strong) solid var(--color-border-subtle);
}
.facts dt {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}
.facts dd {
  display: grid;
  gap: var(--space-1);
  margin: 0;
  overflow-wrap: anywhere;
}
.facts strong {
  font: var(--type-body);
  font-weight: 600;
  color: var(--color-content-primary);
}
.facts span {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}

/* The authorization on the customer's domain: a divided section inside its card, never a nested card. */
.publication {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
  padding-top: var(--space-6);
  border-top: var(--border-default) solid var(--color-border-subtle);
}
.publicationLead {
  margin: 0;
  max-width: 68ch;
  color: var(--color-content-secondary);
}
.publicationTitle {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}
.publishSteps {
  display: grid;
  gap: var(--space-5);
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: publish-step;
}
.publishSteps > li {
  display: grid;
  gap: var(--space-3);
  min-width: 0;
  padding-left: var(--space-8);
  position: relative;
  counter-increment: publish-step;
}
.publishSteps > li::before {
  content: counter(publish-step);
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  place-items: center;
  width: var(--space-6);
  height: var(--space-6);
  border: var(--border-default) solid var(--color-border-default);
  border-radius: 50%;
  font: var(--type-compact);
  font-weight: 600;
}
.stepHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-1) var(--space-3);
  margin: 0;
}
.stepHead span {
  color: var(--color-content-secondary);
  font: var(--type-compact);
  overflow-wrap: anywhere;
}
.domainForm {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: var(--space-3);
}
@media (max-width: 480px) {
  .domainForm {
    grid-template-columns: 1fr;
  }
}
